import React from 'react';
import { fmtTime } from './shared';

const PLATFORM = { woocommerce: 'WooCommerce', shopify: 'Shopify', ikas: 'ikas', tsoft: 'T-Soft', custom: 'Özel' };

const Row = ({ k, children }) => (
  <div className="flex gap-3 text-xs py-1.5 border-b border-gray-100 last:border-0">
    <dt className="w-44 flex-shrink-0 text-gray-500">{k}</dt>
    <dd className="text-gray-900 min-w-0 break-words">{children}</dd>
  </div>
);

export default function SiteInfo({ site }) {
  if (!site || site.unknown) return null;
  const auto = site.auto && typeof site.auto === 'object' ? Object.entries(site.auto) : [];
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4">
      <div className="text-sm font-medium text-gray-900 mb-1">Kurulum bilgisi</div>
      <dl>
        <Row k="Durum">{site.enabled ? <span className="text-emerald-700">Açık</span> : <span className="text-rose-700">Kapalı</span>}</Row>
        <Row k="Platform">{PLATFORM[site.platform] || site.platform || '-'}</Row>
        <Row k="İzinli siteler">{(site.allowed_origins || []).length ? site.allowed_origins.join(', ') : '-'}</Row>
        <Row k="Otomatik olay ayarları">
          {auto.length ? auto.map(([k, v]) => `${k}: ${typeof v === 'object' ? JSON.stringify(v) : String(v)}`).join(' · ') : 'Özel ayar yok (varsayılanlar geçerli)'}
        </Row>
        <Row k="WordPress sunucu güçlendirmesi">{site.has_wp_secret ? 'Var (imzalı sunucu bildirimi tanımlı)' : 'Yok'}</Row>
        <Row k="Kurulum tarihi">{site.created_at ? fmtTime(site.created_at) : '-'}</Row>
      </dl>
    </div>
  );
}
